<template>
    <div id="app">
        <van-nav-bar
                :title="albumTitle"
                right-text=""
                border="false"
                fixed="true"
                left-arrow
                style="color:#fff; background: rgb(183, 41, 21);height: 46px;"
                @click-left="goback"
        />
        <div >

            <div   class="activityDemo2_container" style="margin-top: 46px;padding-bottom:200px">
                <div  class="goodsItems">
                    <div  class="header_content" v-show="false"
                         style="background: rgb(183, 41, 21);margin-top: 46px;"></div>
                    <div  class="banner_wrap" v-show="false"><a  href="javascript:void(0);"><img

                            src="https://img.alicdn.com/imgextra/i3/2053469401/O1CN01YKHvRE2JJi98zWGyS_!!2053469401.jpg"
                            alt="" class="banner"></a></div>
                    <div  class="main" >
                        <div >
                            <div class="goods-row">
                                <div  class="goods-row1" v-for="(item, index) in goodsList" :key="index">

                                    <AlbumTbItem :item="item" :subsidy="tbSubsidy(item)"
                                                  :sales="item.volume" :rebate="tbRebateFee(item)"
                                    ></AlbumTbItem>

                                </div>
                            </div>
                            <div  class="van-loading van-loading--circular van-loading--vertical"
                                 style="padding-top: 0.2rem;" v-show="false">
                                <span
                                                                    class="van-loading__spinner van-loading__spinner--circular"
                                                                    style="width: 24px; height: 24px;"><svg
                                     viewBox="25 25 50 50" class="van-loading__circular"><circle
                                     cx="50" cy="50" r="20" fill="none"></circle></svg></span><span
                                     class="van-loading__text">加载中...</span></div>
                        </div>
                    </div>
                </div>
                <div  class="goodsItems"><!---->
                    <div  class="banner_wrap"><!----></div><!----></div>
                <div data-v-edb3a8ec=""  class="intersection-observer"></div>
            </div>
        </div><!---->
        <div data-v-dcf42b9a="">
            <div class="scroll-top"><!----><a class="top"
                                                                 style="display: none;"><span data-v-dcf42b9a=""><i
                    data-v-26d49cba="" class="iconfont icon-huidingbusvg "></i>顶部</span></a></div>
            <div class="pop_up"><!----><!----></div>
        </div><!----></div>
</template>
<script>
    import {PullRefresh, DropdownMenu, DropdownItem} from "vant";
    import NoData from "@/components/NoData";
    import fetch from '../../libs/fetch'
    import {Dialog} from 'vant'
    import Coupon from '../../libs/coupon'
    import {mapState} from 'vuex'
    import AlbumTbItem from "@/components/good/AlbumTbItem";

    export default {
        components: {
            [PullRefresh.name]: PullRefresh,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
            NoData,
            AlbumTbItem
        },


        data() {
            return {
                albumId: '',
                goodsList: [],

                loading: false,
                finished: false,
                refreshing: false,

                showGoTop: false,
                album: [],
                albumTitle:'',

            };
        },
        computed: {
            ...mapState([
                'appConfig',
                'userInfo',
            ])

        },


        created() {
            this.albumId = this.$route.params.albumId
            this.initData();
        },
        methods: {
            goback(){
                this.$router.go(-1)
            },
            tbCouponPrice(item, appConfig, userInfo) {
                return Coupon.tbCouponPrice(parseFloat(item.actualPrice)+parseInt(item.couponPrice), item.couponPrice, item.commissionRate, appConfig.subsidyCommonLimit, userInfo, appConfig, '1');
            },
            tbSubsidy(item) {
                let subsidy = Coupon.tbSubsidyFee(parseFloat(item.actualPrice)+parseInt(item.couponPrice), item.couponPrice, item.commissionRate, this.appConfig.subsidyCommonLimit, this.userInfo, this.appConfig);
                return subsidy
            },
            tbRebateFee(item) {
                let rebateFee = Coupon.tbRebateFee(parseFloat(item.actualPrice)+parseInt(item.couponPrice), item.couponPrice, item.commissionRate, this.appConfig.subsidyCommonLimit, this.userInfo, this.appConfig, "1");
                return rebateFee
            },
            navToSearch() {
                this.$router.push({
                    name: 'search'
                })
            },
            // 获取商品分类
            initData: function () {
                this.getAlbumGoods()
            },

            goTop() {
                var item = document.querySelector('#home_header');
                item.scrollIntoView({
                    block: "start",//默认跳转到顶部
                    behavior: "smooth"//滚动的速度
                });
            },



            checkscroll: function (e) {
                if (e.srcElement.scrollTop > 600) {
                    if (!this.showGoTop) {
                        this.showGoTop = true
                    }
                } else {
                    if (this.showGoTop) {
                        this.showGoTop = false
                    }
                }

            },


            // 根据分类和商品类型检索商品
            getAlbumGoods: function () {
                let url = '/pdd-goods/public/album/'+this.albumId+'/goods';
                fetch({
                    url: url,
                    method: 'get'
                }).then(response => {
                    this.albumTitle = response.data.albumName;
                    this.goodsList = response.data.goodslist;
                }).catch(error => {
                    console.log(error)
                    Dialog.alert({
                        title: '系统提示',
                        message: error
                    }).then(() => {
                        // on close
                    })
                });

            },
        }
    }

</script>
<style>
    #app, body, html {
        font-family: PingFang SC, Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
        font-size: .24rem;
        box-sizing: border-box;
    }



    a:-webkit-any-link {
        color: -webkit-link;
        cursor: pointer;
        text-decoration: none;
    }

    a {
        text-decoration: none;
    }

    p {
        display: block;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
    }

    button, input, textarea {
        color: inherit;
        font: inherit;
    }

    li {
        display: list-item;
        text-align: -webkit-match-parent;
    }

    ul {
        display: block;
        list-style-type: disc;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        padding-inline-start: 40px;
    }

    ol, ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .activityDemo2_container {
        background-color: #f6f6f6;
        height: 100%;
    }

    .activityDemo2_container .goodsItems{
        min-height: 50%;
    }

    .activityDemo2_container .header_content {
        width: 100%;
        height: 2.16rem;
        background-image: linear-gradient(
                90deg
                ,#f66139,#f23434);
    }
    .activityDemo2_container .banner_wrap {
        text-align: center;
        width: 100%;
    }
    .activityDemo2_container .banner_wrap .banner {
        width: 7.1rem;
        margin-top: -2.1rem;
        border-radius: 0.1rem;
    }
    .goods-row {
        margin-left: 0.2rem;
    }

    .van-hairline--bottom::after{
        border:0
    }
    .van-nav-bar .van-icon {
        color: #fff;
    }
    .van-nav-bar__title {
        color: #fff !important;
    }

    .activityDemo2_container .activityDemo2_header .van-nav-bar {
        background-image: linear-gradient(
                90deg
                ,#f66139,#f23434);
        z-index: 13;
    }

</style>